// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"08064b5f","123":"b5a03d98","140":"908f6e9e","330":"74066e95","388":"1db11220","447":"fd61dbfa","519":"093f1c0b","615":"58347aa0","637":"a4c0bde1","702":"678d3aa5","787":"488ec3a8"}[chunkId] + ".chunk.js";
};